/* cv-search — colavo search that sells (N8, 2026-09-02, staged/w81_search.py).
 *
 * Shopify's storefront search cannot be re-ranked from a theme, so this file
 * rewrites the QUERY before the engine sees it and dresses what comes back:
 *   1. rewrite(): hangul → English (선크림 → sun cream, 달팽이 → snail), brand
 *      transliterations (조선미녀 → beauty of joseon), the sunscreen family, and
 *      k-pop → tag:kpop-official for the predictive engine (which otherwise
 *      splits the hyphen and answers with popcorn);
 *   2. the dropdown gets a pinned "Shop the shelf" row for the shelf the typed
 *      word names, and its "Search for" button keeps the shopper's own words;
 *   3. an empty drawer shows Recent searches (localStorage cv:recent) and the
 *      Popular shelves / Brands panel rendered by snippets/cv-search-start.liquid;
 *   4. the results page: a rewritten URL says "Showing results for snail — you
 *      searched 달팽이", and a strip names the matching shelves above the grid.
 * Text only — no icon sets (owner ruling 2026-09-01).
 */
(function () {
  'use strict';
  var RECENT_KEY = 'cv:recent';
  var RECENT_MAX = 6;

  /* ---------------------------------------------------------------- rewrite */
  // [key, replacement] — hangul keys match as substrings, latin keys whole-word.
  var SUBS = [
    // brands (transliterations shoppers type)
    ['코스알엑스', 'cosrx'], ['코스아르엑스', 'cosrx'], ['아누아', 'anua'], ['조선미녀', 'beauty of joseon'],
    ['메디큐브', 'medicube'], ['라운드랩', 'round lab'], ['토리든', 'torriden'], ['아비브', 'abib'],
    ['스킨1004', 'skin1004'], ['스킨천사', 'skin1004'], ['달바', "d'alba"], ['미샤', 'missha'],
    ['이니스프리', 'innisfree'], ['닥터지', 'dr.g'], ['센텔리안24', 'centellian24'], ['센텔리안', 'centellian'],
    ['넘버즈인', 'numbuzin'], ['바이오던스', 'biodance'], ['티르티르', 'tirtir'], ['롬앤', 'rom&nd'],
    ['클리오', 'clio'], ['페리페라', 'peripera'], ['에뛰드', 'etude'], ['브이티', 'vt'], ['마녀공장', 'ma:nyo'],
    ['성분에디터', 'sungboon editor'], ['아이소이', 'isoi'], ['이즈앤트리', 'isntree'], ['구달', 'goodal'],
    ['메디힐', 'mediheal'], ['원씽', 'one thing'], ['라네즈', 'laneige'], ['설화수', 'sulwhasoo'], ['헤라', 'hera'],
    ['아임프롬', "i'm from"], ['굿라이트', 'good light'], ['에브리루틴', 'every routine'], ['클레어스', 'klairs'],
    ['썸바이미', 'some by mi'], ['닥터자르트', 'dr.jart'], ['벤톤', 'benton'], ['네오젠', 'neogen'],
    ['편강율', 'pyunkang yul'], ['바닐라코', 'banila co'], ['빌리프', 'belif'], ['아이오페', 'iope'],
    ['힌스', 'hince'], ['데이지크', 'dasique'], ['에스트라', 'aestura'], ['팜스테이', 'farmstay'],
    ['아모레', 'amorepacific'], ['올리브영', 'olive young'],
    // categories & formats
    ['선크림', 'sun cream'], ['썬크림', 'sun cream'], ['선스틱', 'sun stick'], ['썬스틱', 'sun stick'],
    ['선세럼', 'sun serum'], ['자외선차단제', 'sunscreen'], ['자외선', 'sunscreen'], ['선케어', 'suncare'],
    ['달팽이', 'snail'], ['쿠션', 'cushion'], ['토너패드', 'toner pad'], ['토너 패드', 'toner pad'],
    ['패드', 'pad'], ['마스크팩', 'sheet mask'], ['시트마스크', 'sheet mask'], ['마스크', 'mask'],
    ['립틴트', 'lip tint'], ['틴트', 'tint'], ['립밤', 'lip balm'], ['클렌징폼', 'cleansing foam'],
    ['클렌징오일', 'cleansing oil'], ['클렌징', 'cleanser'], ['클렌저', 'cleanser'], ['폼클렌저', 'foam cleanser'],
    ['앰플', 'ampoule'], ['세럼', 'serum'], ['에센스', 'essence'], ['미스트', 'mist'], ['토너', 'toner'],
    ['스킨', 'toner'], ['로션', 'lotion'], ['아이크림', 'eye cream'], ['수분크림', 'moisturizer'],
    ['크림', 'cream'], ['오일', 'oil'], ['레티놀', 'retinol'], ['레티날', 'retinal'],
    ['비타민씨', 'vitamin c'], ['비타민c', 'vitamin c'], ['비타민', 'vitamin'], ['나이아신아마이드', 'niacinamide'],
    ['히알루론산', 'hyaluronic acid'], ['콜라겐', 'collagen'], ['시카', 'cica'], ['병풀', 'centella'],
    ['어성초', 'heartleaf'], ['프로폴리스', 'propolis'], ['세라마이드', 'ceramide'],
    ['연어', 'pdrn'], ['피디알엔', 'pdrn'], ['여드름', 'acne'], ['트러블', 'acne'], ['모공', 'pore'],
    ['미백', 'brightening'], ['잡티', 'dark spot'], ['기미', 'dark spot'], ['주름', 'wrinkle'],
    ['탄력', 'firming'], ['보습', 'hydration'], ['수분', 'hydration'], ['진정', 'soothing'],
    ['민감성', 'sensitive'], ['민감', 'sensitive'], ['지성', 'oily'], ['건성', 'dry skin'],
    ['파운데이션', 'foundation'], ['블러셔', 'blush'], ['블러쉬', 'blush'], ['마스카라', 'mascara'],
    ['아이섀도우', 'eyeshadow'], ['아이라이너', 'eyeliner'], ['메이크업', 'makeup'], ['화장품', 'skincare'],
    ['스킨케어', 'skincare'], ['선물', 'gift'], ['세트', 'set'], ['기획', 'set'],
    // K-pop & goods
    ['케이팝', 'k-pop'], ['앨범', 'album'], ['포토카드', 'photocard'], ['포카', 'photocard'],
    ['응원봉', 'light stick'], ['굿즈', 'goods'], ['바인더', 'binder'], ['탑로더', 'toploader'],
    ['다이어리', 'diary'], ['스티커', 'sticker'], ['문구', 'stationery'], ['양말', 'socks'],
    ['인형', 'plush'], ['키링', 'keyring'],
    // groceries
    ['라면', 'ramen'], ['김치', 'kimchi'], ['과자', 'snack'], ['간식', 'snack'], ['초콜릿', 'chocolate'],
    ['커피', 'coffee'], ['영양제', 'supplement'], ['오메가', 'omega'], ['유산균', 'probiotic'],
    ['고추장', 'gochujang'], ['견과류', 'nuts'], ['트레이더조', "trader joe's"],
    ['코스트코', 'costco'], ['커클랜드', 'kirkland'],
    // english families the engine does not join by itself
    ['suncream', 'sun cream'], ['sun screen', 'sunscreen'], ['sunblock', 'sunscreen'], ['sun block', 'sunscreen'],
    ['photo card', 'photocard'], ['lightstick', 'light stick'], ['k pop', 'k-pop'], ['kpop', 'k-pop'],
    ['moisturiser', 'moisturizer'], ['trader joes', "trader joe's"], ['trader joe', "trader joe's"]
  ].sort(function (a, b) { return b[0].length - a[0].length; });

  var HANGUL = /[ㄱ-ㆎ가-힣]/;
  var LATIN_TOKEN = /[a-z0-9&'.:-]/;

  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  function applySubs(s) {
    var out = s;
    for (var i = 0; i < SUBS.length; i++) {
      var key = SUBS[i][0], rep = SUBS[i][1];
      if (out.indexOf(key) === -1) continue;
      if (HANGUL.test(key)) {
        out = out.split(key).join(' ' + rep + ' ');
      } else {
        out = out.replace(new RegExp("(^|[^a-z0-9'])" + escapeRe(key) + "(?=$|[^a-z0-9'])", 'g'), '$1' + rep);
      }
    }
    return norm(out);
  }

  // Predictive-only scoping: the dropdown engine ranks by title prefix, so the
  // words that drown in body text get title:-scoped; k-pop becomes the tag the
  // Official K-pop collection is built from.
  var TITLE_SCOPE = { snail: 1, album: 1 };
  var KPOP = /(^| )k-pop(?= |$)/g;

  function rewrite(raw) {
    var n = norm(raw);
    var q = n ? applySubs(n) : '';
    var pq = q;
    if (TITLE_SCOPE[q]) pq = 'title:' + q;
    if (KPOP.test(q)) pq = q.replace(KPOP, '$1tag:kpop-official');
    KPOP.lastIndex = 0;
    return { typed: String(raw || ''), q: q, pq: pq, changed: q !== n };
  }

  /* ------------------------------------------------------------- shelf aliases */
  // [keys, handle, title]; keys are matched against the REWRITTEN query.
  var SHELVES = [
    [['nct dream'], 'kpop-nct-dream', 'NCT DREAM'],
    [['nct 127'], 'kpop-nct-127', 'NCT 127'],
    [['exo'], 'kpop-exo', 'EXO'],
    [['k-pop', 'bts', 'stray kids', 'skz', 'twice', 'txt', 'tomorrow x together', 'seventeen', 'svt', 'ateez',
      'le sserafim', 'newjeans', 'ive', 'itzy', 'nct', 'exo', 'aespa', 'blackpink', 'enhypen', 'taemin', 'jennie',
      'jisoo', 'riize', 'red velvet', 'wayv', 'pentagon', 'sf9', 'cortis', 'album', 'light stick', 'photobook',
      'idol', 'comeback'], 'official-k-pop', 'Official K-pop'],
    [['photocard', 'binder', 'toploader', 'top loader', 'deco', 'collect book', 'photocard holder'],
      'k-pop-essentials', 'Photocard Storage & Deco'],
    [['fandom', 'goods'], 'fandom', 'Fandom Goods'],
    [['sunscreen', 'sun cream', 'sun stick', 'sun serum', 'suncare', 'spf', 'uv', 'sun'], 'suncare', 'Sunscreen & SPF'],
    [['snail', 'mucin'], 'ingredient-snail', 'Snail Mucin'],
    [['cushion'], 'cushion-foundation', 'Cushion Foundation'],
    [['toner pad', 'pads', 'pad'], 'toner-pads', 'Toner Pads'],
    [['toner'], 'toners', 'Toners'],
    [['pdrn', 'salmon dna', 'salmon'], 'ingredient-pdrn', 'PDRN (Salmon DNA)'],
    [['retinol', 'retinal'], 'ingredient-retinol', 'Retinol'],
    [['vitamin c', 'vit c'], 'ingredient-vitamin-c', 'Vitamin C'],
    [['niacinamide'], 'ingredient-niacinamide', 'Niacinamide'],
    [['centella', 'cica'], 'ingredient-centella', 'Centella (Cica)'],
    [['collagen'], 'ingredient-collagen', 'Collagen'],
    [['hyaluronic acid', 'hyaluronic'], 'ingredient-hyaluronic', 'Hyaluronic Acid'],
    [['heartleaf'], 'ingredient-heartleaf', 'Heartleaf'],
    [['rice'], 'ingredient-rice', 'Rice Extract'],
    [['propolis'], 'ingredient-propolis', 'Propolis'],
    [['ceramide'], 'ingredient-ceramide', 'Ceramides'],
    [['lip tint', 'tint', 'lip'], 'lip-tints', 'Lip Tints'],
    [['sheet mask', 'mask pack', 'mask', 'masks'], 'masks', 'Masks'],
    [['cleansing foam', 'cleansing oil', 'foam cleanser', 'cleanser', 'cleansing', 'face wash', 'foam'],
      'cleansers', 'Cleansers & Face Wash'],
    [['serum', 'essence', 'ampoule'], 'serums-essences', 'Serums & Essences'],
    [['moisturizer', 'gel cream', 'cream', 'lotion', 'eye cream'], 'moisturizers-creams', 'Moisturizers & Creams'],
    [['acne', 'pimple', 'blemish', 'breakout', 'spot patch', 'pimple patch', 'pore'], 'acne-blemish-care',
      'Acne & Breakouts'],
    [['brightening', 'dark spot', 'whitening', 'glow'], 'brightening-dark-spots', 'Dark Spots & Brightening'],
    [['hydration', 'hydrating'], 'hydration', 'Hydration'],
    [['anti-aging', 'anti aging', 'wrinkle', 'firming', 'lifting'], 'anti-aging', 'Anti-Aging'],
    [['sensitive', 'redness', 'soothing'], 'skin-type-sensitive', 'Sensitive Skin'],
    [['oily'], 'skin-type-oily', 'Oily Skin'],
    [['dry skin'], 'skin-type-dry', 'Dry Skin'],
    [['gift', 'set', 'kit', 'bundle', 'duo'], 'routine-sets', 'Sets & Gifts'],
    [['makeup', 'foundation', 'blush', 'mascara', 'eyeshadow', 'eyeliner'], 'makeup', 'Makeup'],
    [['skincare'], 'skincare', 'Skincare'],
    [["trader joe's"], 'us-trader-joes', "Trader Joe's"],
    [['costco', 'kirkland'], 'us-costco', 'Costco'],
    [['snack', 'snacks', 'chips', 'cookie', 'cookies', 'chocolate', 'candy', 'popcorn', 'nuts', 'seaweed'],
      'us-snacks', 'Snacks & Chocolate'],
    [['coffee', 'tea', 'matcha'], 'us-coffee-tea', 'Coffee & Tea'],
    [['supplement', 'supplements', 'vitamin', 'omega', 'probiotic', 'magnesium'], 'us-supplements',
      'Vitamins & Supplements'],
    [['pantry', 'sauce', 'pasta', 'honey', 'ramen', 'noodle', 'gochujang', 'kimchi'], 'us-pantry', 'Pantry Staples'],
    [['seasoning', 'spice', 'salt', 'pepper'], 'us-seasonings', 'Seasonings & Spices'],
    [['sprouts'], 'us-sprouts', 'Sprouts Farmers Market'],
    [['candle'], 'us-home', 'Home & Candles'],
    [['new'], 'new-from-korea', 'New from Seoul'],
    [['best', 'bestseller', 'best seller', 'popular', 'start'], 'best-sellers', 'Where to Start'],
    [['stationery', 'pen', 'notebook', 'sticker', 'diary', 'planner'], 'paper-desk', 'Stationery & Desk'],
    [['toy', 'figure', 'plush', 'keyring', 'keychain'], 'toys-collectibles', 'Toys & Collectibles'],
    [['socks'], 'socks', 'Socks'],
    [['bag', 'pouch'], 'bags-pouches', 'Bags & Pouches'],
    [['hair', 'earring', 'hair clip'], 'jewelry-hair', 'Jewelry & Hair'],
    // brands on the shelf
    [['cosrx'], 'cosrx', 'COSRX'], [['anua'], 'anua', 'Anua'], [['medicube'], 'medicube', 'MEDICUBE'],
    [['beauty of joseon'], 'beauty-of-joseon', 'Beauty of Joseon'], [['torriden'], 'torriden', 'Torriden'],
    [['skin1004'], 'skin1004', 'SKIN1004'], [['abib'], 'abib', 'Abib'], [['numbuzin'], 'numbuzin', 'numbuzin'],
    [['biodance'], 'biodance', 'BIODANCE'], [['clio'], 'clio', 'CLIO'], [['rom&nd', 'romand', 'rom and'], 'romandnd', 'rom&nd'],
    [['sungboon editor', 'sungboon'], 'sungboon-editor', 'SUNGBOON EDITOR'], [["i'm from", 'im from'], 'im-from', "I'M FROM"],
    [['good light', 'goodlight'], 'good-light', 'GOOD LIGHT'], [['every routine'], 'every-routine', 'EVERY ROUTINE'],
    [['missha'], 'missha', 'MISSHA'], [['innisfree'], 'innisfree', 'Innisfree'], [['dr.g', 'dr g'], 'dr-g', 'Dr.G'],
    [['centellian24', 'centellian'], 'centellian24', 'Centellian24'], [['isntree'], 'isntree', 'ISNTREE'],
    [['goodal'], 'goodal', 'Goodal'], [['mediheal'], 'mediheal', 'MEDIHEAL'], [['one thing'], 'one-thing', 'ONE THING'],
    [['klairs'], 'klairs', 'KLAIRS'], [['etude'], 'etude', 'ETUDE'], [['some by mi'], 'some-by-mi', 'SOME BY MI'],
    [['dr.jart', 'dr jart'], 'dr-jart', 'Dr.Jart+'], [['benton'], 'benton', 'BENTON'], [['neogen'], 'neogen', 'NEOGEN'],
    [['pyunkang yul'], 'pyunkang-yul', 'Pyunkang Yul'], [['banila co'], 'banila-co', 'BANILA CO'],
    [['belif'], 'belif', 'belif'], [['iope'], 'iope', 'IOPE'], [['hince'], 'hince', 'hince'],
    [['dasique'], 'dasique', 'dasique'], [['aestura'], 'aestura', 'AESTURA'], [['farmstay'], 'farmstay', 'Farmstay'],
    [['ma:nyo', 'manyo'], 'manyo', 'ma:nyo'], [['ahc'], 'ahc', 'AHC'], [['artbox'], 'artbox', 'ARTBOX'],
    [['monami'], 'monami', 'Monami']
  ];

  function keyHits(q, key) {
    if (HANGUL.test(key)) return q.indexOf(key) !== -1;
    return new RegExp("(^|[^a-z0-9'])" + escapeRe(key) + "(?=$|[^a-z0-9'])").test(q);
  }

  // Shelves the rewritten query names, longest matched key first; a key that is
  // a substring of a longer hit ("cream" inside "sun cream") is dropped.
  function shelvesFor(q, max) {
    var hits = [];
    for (var i = 0; i < SHELVES.length; i++) {
      var keys = SHELVES[i][0];
      for (var k = 0; k < keys.length; k++) {
        if (keyHits(q, keys[k])) { hits.push({ key: keys[k], handle: SHELVES[i][1], title: SHELVES[i][2] }); break; }
      }
    }
    hits.sort(function (a, b) { return b.key.length - a.key.length; });
    var out = [], seen = {};
    for (var j = 0; j < hits.length; j++) {
      var h = hits[j], shadowed = false;
      for (var m = 0; m < out.length; m++) {
        if (out[m].key !== h.key && out[m].key.indexOf(h.key) !== -1) { shadowed = true; break; }
      }
      if (shadowed || seen[h.handle]) continue;
      seen[h.handle] = 1;
      out.push(h);
      if (out.length >= max) break;
    }
    return out;
  }

  /* ------------------------------------------------------------------- utils */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function searchHref(typed) {
    var rw = rewrite(typed);
    var u = '/search?q=' + encodeURIComponent(rw.q) + '&options%5Bprefix%5D=last';
    if (rw.changed) u += '&cv_q=' + encodeURIComponent(typed);
    return u;
  }

  /* ------------------------------------------------------------------ recent */
  function recent() {
    try { var v = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }

  function saveRecent(items) { try { localStorage.setItem(RECENT_KEY, JSON.stringify(items)); } catch (e) { /* private mode */ } }

  function pushRecent(term) {
    var t = String(term || '').trim();
    if (!t || t.length > 60) return;
    var items = recent().filter(function (x) { return norm(x) !== norm(t); });
    items.unshift(t);
    saveRecent(items.slice(0, RECENT_MAX));
  }

  function renderRecent() {
    var items = recent();
    var boxes = document.querySelectorAll('[data-cv-search-recent]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i], list = box.querySelector('[data-cv-recent-list]');
      if (!list) continue;
      list.innerHTML = items.map(function (t) {
        return '<a href="' + searchHref(t) + '">' + esc(t) + '</a>';
      }).join('');
      box.hidden = !items.length;
    }
  }

  /* ------------------------------------------------------------- start panel */
  function syncStart(ps) {
    if (!ps || !ps.input) return;
    var panel = ps.querySelector('[data-cv-search-start]');
    if (!panel) return;
    var on = !ps.input.value.trim();
    if (on) renderRecent();
    panel.classList.toggle('is-on', on);
  }

  function psOf(el) { return el && el.closest ? el.closest('predictive-search') : null; }

  document.addEventListener('focusin', function (e) {
    if (e.target && e.target.matches && e.target.matches('predictive-search input[type="search"]')) syncStart(psOf(e.target));
  });
  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('predictive-search input[type="search"]')) syncStart(psOf(e.target));
  });
  document.addEventListener('reset', function (e) {
    var ps = psOf(e.target);
    if (ps) setTimeout(function () { syncStart(ps); }, 0);
  });
  // <details> toggle does not bubble — capture it, then sync every drawer instance.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.closest || !d.closest('details-modal.header__search')) return;
    var all = d.querySelectorAll('predictive-search');
    for (var i = 0; i < all.length; i++) syncStart(all[i]);
  }, true);
  document.addEventListener('click', function (e) {
    var clear = e.target.closest ? e.target.closest('[data-cv-recent-clear]') : null;
    if (clear) { e.preventDefault(); saveRecent([]); renderRecent(); return; }
    var a = e.target.closest ? e.target.closest('predictive-search [data-predictive-search] a') : null;
    if (a) { var ps = psOf(a); if (ps && ps.input) pushRecent(ps._cvTyped || ps.input.value); }
  });

  /* ----------------------------------------------------- dropdown decoration */
  function decorate(ps) {
    var typed = (ps._cvTyped || (ps.input && ps.input.value) || '').trim();
    var box = ps.querySelector('#predictive-search-results');
    if (!box) return;
    var sft = ps.querySelector('[data-predictive-search-search-for-text]');
    if (sft && typed) sft.textContent = 'Search for “' + typed + '”';
    var old = box.querySelector('.cv-spin');
    if (old) old.remove();
    var shelves = shelvesFor(rewrite(typed).q, 2);
    if (!shelves.length) return;
    var ul = document.createElement('ul');
    ul.className = 'predictive-search__results-list list-unstyled cv-spin';
    ul.setAttribute('role', 'group');
    ul.setAttribute('aria-label', 'Categories');
    ul.innerHTML = shelves.map(function (s, i) {
      return '<li id="cv-spin-' + (i + 1) + '" class="predictive-search__list-item" role="option" aria-selected="false">' +
        '<a href="/collections/' + s.handle + '" class="predictive-search__item link link--text" tabindex="-1">' +
        '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
        '<p class="predictive-search__item-heading h5"><span class="cv-spin__kicker">Shop all</span>' + esc(s.title) + '</p>' +
        '</div></a></li>';
    }).join('');
    box.insertBefore(ul, box.firstChild);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('predictive-search').then(function () {
      var C = customElements.get('predictive-search');
      if (!C || C.prototype._cvPatched) return;
      var P = C.prototype;
      var getResults = P.getSearchResults, render = P.renderSearchResults;
      P.getSearchResults = function (term) {
        this._cvTyped = term;
        var rw = rewrite(term);
        return getResults.call(this, rw.pq || rw.q || term);
      };
      P.renderSearchResults = function (markup) {
        render.call(this, markup);
        try { decorate(this); } catch (e) { /* never break the dropdown */ }
      };
      P._cvPatched = true;
    });
  }

  /* ------------------------------------------------------------------ submit */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[role="search"]')) return;
    var inp = f.querySelector('input[name="q"]');
    if (!inp) return;
    var typed = inp.value.trim();
    if (!typed) return;
    if (f.querySelector('[aria-selected="true"] a')) return;   // Dawn navigates the selected option instead
    pushRecent(typed);
    var rw = rewrite(typed);
    if (!rw.changed) return;
    inp.value = rw.q;
    var h = f.querySelector('input[name="cv_q"]');
    if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.name = 'cv_q'; f.appendChild(h); }
    h.value = typed;
  }, true);

  /* ------------------------------------------------------------ results page */
  function showingFor(q, typed) {
    var el = document.querySelector('[data-cv-showing-for]');
    if (!el) return;
    var raw = '/search?q=' + encodeURIComponent(typed) + '&cv_q=' + encodeURIComponent(typed) + '&options%5Bprefix%5D=last';
    el.innerHTML = 'Showing results for <strong>' + esc(q) + '</strong> — you searched “' + esc(typed) + '”.' +
      ' <a href="' + raw + '">Search “' + esc(typed) + '” as typed</a>';
    el.hidden = false;
  }

  function renderMatches(q) {
    var el = document.querySelector('[data-cv-shelves-match]');
    if (!el) return;
    var rw = rewrite(q);
    var shelves = shelvesFor(rw.q, 6);
    var draw = function () {
      if (!shelves.length) return;
      el.innerHTML = '<span class="cv-searchshelves__label">Categories for “' + esc(rw.typed) + '”:</span>' +
        shelves.map(function (s) { return '<a href="/collections/' + s.handle + '">' + esc(s.title) + '</a>'; }).join('');
      el.hidden = false;
    };
    draw();
    // The engine's own collection matches fill in what the alias map does not know.
    var u = '/search/suggest.json?q=' + encodeURIComponent(rw.q) + '&resources[type]=collection&resources[limit]=6';
    fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      var cols = (j && j.resources && j.resources.results && j.resources.results.collections) || [];
      var seen = {};
      shelves.forEach(function (s) { seen[s.handle] = 1; });
      cols.forEach(function (c) {
        if (!c || !c.handle || seen[c.handle] || shelves.length >= 8) return;
        seen[c.handle] = 1;
        shelves.push({ key: '', handle: c.handle, title: c.title });
      });
      draw();
    }).catch(function () { /* the alias strip already drew */ });
  }

  function onResultsPage() {
    var sp = new URLSearchParams(location.search);
    var q = sp.get('q') || '', cvq = sp.get('cv_q');
    if (q && !cvq) {
      var rw = rewrite(q);
      if (rw.changed) {
        sp.set('q', rw.q);
        sp.set('cv_q', q);
        location.replace(location.pathname + '?' + sp.toString());
        return;
      }
    }
    if (q && cvq && norm(cvq) !== norm(q)) showingFor(q, cvq);
    if (q) renderMatches(cvq || q);
    var tell = document.querySelector('[data-cv-zero-tell]');
    if (tell) {
      tell.addEventListener('click', function (e) {
        var em = document.querySelector('footer input[type="email"], .footer input[type="email"]');
        if (!em) return;
        e.preventDefault();
        em.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { em.focus(); }, 400);
      });
    }
  }

  function boot() {
    renderRecent();
    if (location.pathname.indexOf('/search') === 0) onResultsPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  window.cvSearch = { rewrite: rewrite, shelvesFor: shelvesFor };
})();
